import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import LoadingButton from '@mui/lab/LoadingButton';

import Session from './Session';

import GoogleButton from 'react-google-button'


export default class LoginDialog extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            open: false,
            loading: false
        };

        Session.loginDialog = this;
    }

    setOpen = () => {
        if (this.state.open) {
            return;
        }
        this.setState({
            open: true,
            loading: false
        });
    };

    close = () => {
        if (!this.state.open) {
            return;
        }
        this.setState({
            open: false
        });
    };

    handleLoginResult = (result: any) => {
        localStorage.setItem(Session.TOKEN_KEY, result);
        Session.token = result;
        Session.verify_token(false, true);
    }

    handleLoginError = (result: any) => {
        (document.activeElement as HTMLElement).blur();
        (document.getElementById("login-form") as HTMLFormElement).reset();
        Session.app.setState({
            snackbarOpen: true,
            snackbarSeverity: "error",
            message: result
        });
        this.setState({
            loading: false
        });
    }

    defaultLogin = (e: any) => {
        e.preventDefault();
        this.setState({
            loading: true
        });
        const { email, password } = e.target.elements;
        Session.login(
            email.value,
            password.value,
            this.handleLoginResult,
            this.handleLoginError
        );
    };

    render() {
        return (
            <div>
                <Dialog open={this.state.open} onClose={this.close}>
                    <form id="login-form" onSubmit={this.defaultLogin}>
                        <DialogTitle>Login Requied</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                To continue, please login. Registration is currently unavailable.
                            </DialogContentText>
                            <br/>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="email"
                                name="email"
                                label="Email Address"
                                type="email"
                                autoComplete="on"
                                fullWidth
                                variant="standard"
                            />
                            <br/>
                            <br/>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                                autoComplete="on"
                                fullWidth
                                variant="standard"
                            />
                        </DialogContent>
                        <DialogActions style={{ textAlign: "center", display: "block" }}>
                            <LoadingButton
                                type="submit"
                                endIcon={<EmojiPeopleIcon />}
                                loading={this.state.loading}
                                loadingPosition="end"
                                size="large"
                                variant="contained"
                            >
                                Login
                            </LoadingButton>
                        </DialogActions>
                    </form>
                        <DialogActions style={{ margin: "auto" }}>
                            <GoogleButton onClick={() => { Session.googleLoginHook(); }}/>
                        </DialogActions>
                    {/* } */}
                </Dialog>
            </div>
        );
    }
}
